<template>
   <div class="footer txt-center">
        Copyright ⓒ<span class="bold">CARROT</span> Inc. All Right reserved.<br>
        문의 │ spac@carrotglobal.com
    </div>
</template>

<script>
export default {
  name: 'footer',
  props: {
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">

</style>
